




import mixins from 'vue-typed-mixins'
import Section from '../mixins/Section'

export default mixins(Section).extend({
  name: 'PlainHtml1'
})
